module.exports = __webpack_public_path__ + "static/media/Involved1.87b9e025.svg";